module.exports = __webpack_public_path__ + "static/media/Capture.b035f400.JPG";